import { el, mount, RedomComponent, unmount } from 'redom';
import { LogHelpers } from '../logHelper';

export class S4yModal {
  private body = document.querySelector('body');
  private modalElement: HTMLDivElement;
  private modalContentElement: HTMLDivElement;
  private backdropElement: HTMLDivElement;
  private id: string;
  private size?: 'sm' | 'lg' | 'xl';
  private centered: boolean;
  private isStatic: boolean;
  private includeCloseButton: boolean;
  private logHelper = new LogHelpers('S4yModal');
  private static globalIndex: number = 0;

  $modalClosed: () => void;

  /**
   * 
   * @param id {string} modal id attribute
   */
  constructor(id: string, size?: 'sm' | 'lg' | 'xl', centered: boolean = false, index: number = 0, isStatic: boolean = false, includeCloseButton: boolean = true) {
    this.id = id;
    this.size = size;
    this.centered = centered;
    this.isStatic = isStatic;
    this.includeCloseButton = includeCloseButton;
    this.buildHtml();
  }

  /**
   * Build modal markup from option
   */
  private buildHtml() {
    const modal = this.getModal();
    this.modalElement = modal.modalElement;
    this.modalContentElement = modal.modalContentElement;
    this.backdropElement = modal.backdropElement;

    // this.body.appendChild(this.modalElement);
    // this.body.appendChild(this.backdropElement);
    mount(this.body, this.modalElement);
    mount(this.body, this.backdropElement);
    window.addEventListener('click', (event: MouseEvent) => {
      if (event.target == this.modalElement && !this.isStatic) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.backdropElement.style.display = "block";
    this.backdropElement.classList.add('d-show');
    this.modalElement.style.display = "block";
    this.modalElement.classList.add('d-show');
    this.body.classList.add('d-modal-open');

    this.modalElement.classList.add(`d-modal-${S4yModal.globalIndex}`);
    this.backdropElement.classList.add(`d-modal-backdrop-${S4yModal.globalIndex}`);
    S4yModal.globalIndex++;
  }

  closeModal() {
    this.backdropElement.style.display = "none";
    this.backdropElement.classList.remove('d-show');
    this.modalElement.style.display = "none";
    this.modalElement.classList.remove('d-show');
    if (S4yModal.globalIndex === 1) {
      this.body.classList.remove('d-modal-open'); 
    }
    unmount(this.body, this.modalElement);
    unmount(this.body, this.backdropElement);
    // this.body.removeChild(this.modalElement);
    // this.body.removeChild(this.backdropElement);
    if (this.$modalClosed) {
      this.$modalClosed();
    }
    if (S4yModal.globalIndex > 0) {
      S4yModal.globalIndex--;
    }
  }

  // ============================
  /**
   * Build this html
   * <div class="d-modal d-fade" id="id">
   *     <div class="d-modal-dialog">
   *         <div class="d-modal-content">
   *         </div>
   *     </div>
   * </div>
   * <div class="d-modal-backdrop d-fade d-show" id="backdrop" style="display: none;"></div>
   * @param id {string} id attribute
   * @returns {HTMLDivElement[]} An array that contain modal and modal content element
   */
  getModal(): {
    modalElement: HTMLDivElement,
    modalContentElement: HTMLDivElement,
    backdropElement: HTMLDivElement
  } {
    const modalContentElement = el('div', { class: 'd-modal-content' });
    let classes = 'd-modal-dialog';
    if (this.size) {
      classes += ` d-modal-${this.size}`;
    }
    if (this.centered) {
      classes += ' d-modal-dialog-centered';
    }
    this.modalElement = el('div', { class: 'd-modal d-fade', id: this.id }, [
      el('div', { class: classes }, [
        modalContentElement
      ])
    ]);
    this.backdropElement = el('div', { class: 'd-modal-backdrop d-fade', id: `${this.id}-backdrop`, style: { display: 'none' } });
    return { 
      modalElement: this.modalElement,
      backdropElement: this.backdropElement,
      modalContentElement: modalContentElement,
    };
  }

  /**
   * Build this html
   * <div class="d-modal-header">
   *      <div class="d-modal-title">
   *      </div>
   *      <button type="button" class="d-close">
   *          <span>&#215;</span>
   *      </button>
   * </div>
   * 
   * @return {{modalHeaderElement: HTMLDivElement, modalTitleElement: HTMLDivElement, closeButtonElement: HTMLButtonElement}}
   */
  getModalHeader(): {
    modalHeaderElement: HTMLDivElement,
    modalTitleElement: HTMLDivElement,
    closeButtonElement: HTMLButtonElement
  } {
    const closeButtonElement = el('button', { type: 'button', class: 'd-close' }, [
      el('span', '×')
    ]);
    const modalTitleElement = el('div', { class: 'd-modal-title' });
    const modalHeaderElement = el('div', { class: 'd-modal-header' }, [
      modalTitleElement,
      this.includeCloseButton ? closeButtonElement : null,
    ]);

    return {
      modalHeaderElement,
      modalTitleElement,
      closeButtonElement: this.includeCloseButton ? closeButtonElement : null,
    };
  }

  /**
   * Build this html
   * <div class="d-modal-body">
   * </div>
   */
  getModalBody(): HTMLDivElement {
    return el('div', { class: 'd-modal-body' });
  }

  /**
   * Build this html
   * <div class="modal-footer">
   * </div>
   */
  getModalFooter(): HTMLDivElement {
    return el('div', { class: 'd-modal-footer' });
  }

  /**
   * Add a section to the modalContentElement
   * @param section {HTMLDivElement} One of three sections you can add to the modalContentElement: modal-header, modal-body, modal-footer
   */
  append(section: HTMLElement | RedomComponent) {
    mount(this.modalContentElement, section);
  }
}